import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import styled from '@emotion/styled'

const Image = () => {
  const data = useStaticQuery(graphql`
    query LoadSidebarImage {
      allImageSharp(filter: {resize: {originalName: {eq: "new_sidebar.png" } } }) {
        edges {
          node {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  `)

  return (
    <ImageWrapper>
      <StyledImg fluid={data.allImageSharp.edges[0].node.fluid} />
    </ImageWrapper>
  )
}

const ImageWrapper = styled.div`
  position: relative;
  height: 100vh;
  width: 100%;
  filter: blur(1px);
`

const StyledImg = styled(Img)`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  height: 100vh;
  width: 100%;
`

export default Image
